import "jquery";
import * as ko from "knockout";
import { BaseCropComponent } from "./BaseCropComponent";
import { OsrDeliveryGroupedByCropNumber } from "../Models/Osr/OsrDeliveryGroupedByCropNumber";

export class OsrDeliveries extends BaseCropComponent<OsrDeliveryGroupedByCropNumber> {
    constructor() {
        super($('#osrdeliveries-table'));
    }
    init(): void {
        this.osrApi.getDeliveries().then((res) => {
            super.init(res, "cropNo", '*[data-bind="text: deliveryCrop.CropNumber"]');
        });
    }
}